import { SET_SITE_PAGES } from '../actions/set-site-pages';
export default function sitePages(state = [], action) {
  switch (action.type) {
    case SET_SITE_PAGES:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/site-pages.js